export default "b543756bde1000a8.svg"